const todayDate = new Date();
const month = todayDate.getMonth();
const day = todayDate.getDate();

const isNewYearTime = (month === 11 && day > 9) || (month === 0 && day < 15);

export default isNewYearTime;
